export const programDetail = 'programDetail';
export const moduleDetail = 'moduleDetail';
export const programDetailOverview = 'programDetailOverview';
export const programMenu = 'programMenu';
